import { ReadyStatePresentation } from "./DynamicChangeSelectField.ready.presenter";
import { WaitingDependencyPresentation } from "./DynamicChangeSelectField.waiting.presenter";
import { DynamicSelectFieldErrorPresentation } from "./DynamicSelectField.error.presenter";
import type { DynamicChangeSelectFieldPresentationProps } from "./DynamicSelectField.type";

/**
 * 動的変更セレクトフィールドのプレゼンテーション層
 */
export const DynamicChangeSelectFieldPresentation = ({
  uiState,
  options,
  value,
  onChange,
  onFocus,
  onBlur,
  disabled,
  readOnly,
  error,
  placeholder,
  testId,
  getSelectedOptionLabel,
  currentValueLabel,
  readOnlyDisplayValue,
}: DynamicChangeSelectFieldPresentationProps) => {
  // エラー状態の場合
  if (uiState.type === "error") {
    return <DynamicSelectFieldErrorPresentation />;
  }

  // 依存待ち状態の場合
  if (uiState.type === "waiting-dependency") {
    return (
      <WaitingDependencyPresentation
        testId={testId}
        currentValue={undefined}
        currentValueLabel={currentValueLabel}
      />
    );
  }

  // 通常状態の場合（type: "ready"）
  return (
    <ReadyStatePresentation
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={disabled}
      readOnly={readOnly}
      error={error}
      placeholder={placeholder}
      testId={testId}
      options={options}
      uiState={uiState}
      getSelectedOptionLabel={getSelectedOptionLabel}
      currentValueLabel={currentValueLabel}
      readOnlyDisplayValue={readOnlyDisplayValue}
    />
  );
};
